(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('CustomerNotificationDeleteController',CustomerNotificationDeleteController);

    CustomerNotificationDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomerNotification'];

    function CustomerNotificationDeleteController($uibModalInstance, entity, CustomerNotification) {
        var vm = this;

        vm.customerNotification = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CustomerNotification.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
